var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleReportIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 142500",
    fill: "none",
    d: "M0 0h24v24H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    transform: "translate(1 .989)",
    fill: "#3b5175"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59624",
    d: "M17 13.011h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Zm0 0h-2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 59625",
    d: "M21 3.012h-4.5v-1.95a1.05 1.05 0 0 0-.85-1.05 1 1 0 0 0-1.15 1v2h-7v-1.95a1.05 1.05 0 0 0-.85-1.05 1 1 0 0 0-1.15 1v2H1a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-16a1 1 0 0 0-1-1Zm-1 16H2v-10h18Zm0-12H2v-2h18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 142501",
    width: 4,
    height: 4,
    rx: 2,
    transform: "translate(14 13.011)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleReportIconNew);
export default __webpack_public_path__ + "static/media/ScheduleReportIconNew.ea1f5ee3d6bd571297a145e4ef2a5b03.svg";
export { ForwardRef as ReactComponent };